import { Pipe, PipeTransform } from '@angular/core';
import { UtilityService } from '../services/utility.service' ;

@Pipe({
  name: 'displayUserRole',
  pure: true,
  standalone: true,
})
export class DisplayUserRole implements PipeTransform {

  constructor(
    private utilityService: UtilityService,
  ) {}

  transform(value: string | undefined): string {
    if (!value) return '' ;

    return this.utilityService.formatUserRoleLabel(value) ;
  }

}
